(function () {
  selectedSlotsDisplay.$inject = ["API_URL", "$interval"];
  angular.module('calendarApp').directive('selectedSlotsDisplay', selectedSlotsDisplay);

  function selectedSlotsDisplay(API_URL, $interval) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/selected-slots-display.html',
      scope: {
        selectedSlots: '=',
        continue: '=',
        cancel: '=',
        showPreview: '@',
        mustAgreeTerms: '=?',
        termsAgreed: '=?'
      },
      link: function link(scope, elem, attrs) {}
    };
  }
})();